import React from "react";
import { Message } from "semantic-ui-react";

export default function NotFound() {
    return (
        <>
            <Message>
                <Message.Header>Error 404</Message.Header>
                Page not found.
            </Message>
        </>
    );
}